import React from "react";
import { useAuth } from "../../context/AuthContext";

const API = process.env.REACT_APP_API_URL || "";

export default function SessionInfo() {
  const { user } = useAuth();

  const handleLogout = async (e) => {
    e.preventDefault();
    await fetch(`${API}/api/logout`, { method: "POST", credentials: "include" });
    window.location.href = "/login";
  };

  if (user === undefined) return null;

  const boxStyle = {
    padding: "12px 20px",
    borderTop: "1px solid rgba(255,255,255,0.15)",
    color: "#fff",
    fontSize: 13,
  };

  if (!user) {
    return (
      <div style={boxStyle}>
        <a href="/login" style={{ color: "#8ab4f8" }}>Se connecter</a>
      </div>
    );
  }

  return (
    <div style={boxStyle}>
      <div style={{ fontWeight: 600 }}>{user.utcNom}</div>
      <div style={{ opacity: 0.7 }}>{user.utcMail}</div>
      <div style={{ opacity: 0.7 }}>
        {user.utcRole ? `Rôle : ${user.utcRole}` : "Aucun rôle assigné"}
      </div>
      <div style={{ opacity: 0.7, marginBottom: 6 }}>
        {user.commissions?.length > 0
          ? `Collège${user.commissions.length > 1 ? "s" : ""} : ${user.commissions.map((c) => c.comLib).join(", ")}`
          : "Aucun collège assigné"}
      </div>
      <a href="#logout" onClick={handleLogout} style={{ color: "#8ab4f8" }}>
        Déconnexion
      </a>
    </div>
  );
}
